export default __webpack_public_path__ + "static/media/close.e68f400e.svg";